import React from 'react';
import PropTypes from 'prop-types';
import { FACETS, facetCount, facetOptions } from './projectListModel';
import { Owner, VendorMark } from './ProjectAtoms';

// Faceted filters with live counts (STRY0038867): each count is what the list
// would show with that option, given the search and the other facets.
const ProjectFilterRail = ({ projects, query, selection, ctx, onToggle, onClear }) => {
  const anyActive = FACETS.some(f => selection[f.key].length > 0);
  return (
    <aside className="pl-rail" aria-label="Filters">
      <div className="pl-rail__head">
        <span className="bz-kicker">Filters</span>
        {anyActive && (
          <button type="button" className="pl-linkbtn" onClick={onClear}>
            Clear all
          </button>
        )}
      </div>
      {FACETS.map(facet => (
        <div key={facet.key} className="pl-facet" role="group" aria-label={facet.title}>
          <div className="pl-facet__title">{facet.title}</div>
          {facetOptions(facet.key, projects, ctx).map(option => {
            const count = facetCount(projects, query, selection, ctx, facet.key, option.id);
            const checked = selection[facet.key].includes(option.id);
            return (
              <label key={option.id || 'none'} className={`pl-facet__opt${count === 0 && !checked ? ' is-zero' : ''}`}>
                <input type="checkbox" checked={checked} onChange={() => onToggle(facet.key, option.id)} />
                {facet.key === 'vendor' && <VendorMark vendorId={option.id} label={option.label} size={18} />}
                {facet.key === 'owner' && (
                  <Owner userId={option.id} currentUserEmail={ctx.currentUserEmail} avatarOnly />
                )}
                <span className="bz-truncate">{option.label}</span>
                {facet.key === 'status' && ctx.availableLoading ? (
                  <span className="pl-skel pl-skel--count" aria-label="Counting" />
                ) : (
                  <span className="pl-facet__count">{count}</span>
                )}
              </label>
            );
          })}
        </div>
      ))}
    </aside>
  );
};

ProjectFilterRail.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
  query: PropTypes.string.isRequired,
  selection: PropTypes.object.isRequired,
  ctx: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default ProjectFilterRail;
